import { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { CellContext } from '@tanstack/react-table';
import { Product } from '@/types/menuStore.types';
import { CustomTableMeta } from '@/components/Tables/TableCard/TableCard.types';
import Input from '@/components/Input/Input';
import { InputStates } from '@/components/Input/Input.types';
import styles from './EditUpchargeInput.module.css';

export const EditUpchargeInput = ({ getValue, row, column, table }: CellContext<Product, unknown>) => {
  const columnMeta = column?.columnDef?.meta;
  const initialValue = getValue<string>();
  const { meta } = table.options;
  const { editedRows, cancelEdition, setCancelEdition, updateData, revertData, setEditedRows, loadingData } =
    meta as CustomTableMeta<Product>;

  const { index: rowIndex } = row;
  const editing = !!(editedRows && editedRows[Number(row.id)]);

  const [value, setValue] = useState(initialValue);
  const [state, setState] = useState(InputStates.Default);

  const isValidInput = (inputValue: string) => {
    const validate = columnMeta?.validate;
    return validate ? validate(Number(inputValue), row.original) : true;
  };

  const handleOnChangeInput = (inputValue: string) => {
    const isValid = isValidInput(inputValue);
    if (isValid) {
      setValue(inputValue);
      setState(InputStates.Success);
      updateData(row.index, column.id, inputValue);
    } else {
      updateData(row.index, column.id, value);
      setState(InputStates.Error);
    }
  };
  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    if (cancelEdition && cancelEdition[rowIndex] === true) {
      handleOnChangeInput(initialValue); // need to set the original value when the user cancel the operation
    }
  }, [cancelEdition]);

  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="end"
      sx={{
        paddingTop: '0px',
        m: 0,
      }}
    >
      {!editing && (
        <Grid
          item
          xs={2}
          sx={{
            minWidth: '20px',
            width: '30px',
          }}
        >
          ${loadingData ? '...' : (+value || 0).toFixed(2)}
        </Grid>
      )}

      {/* needs validation */}
      {editing && (
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          sx={{
            minWidth: '2px',
          }}
        >
          <Grid
            item
            alignItems="center"
            justifyContent="flex-start"
            xs={2}
            sx={{
              minWidth: '100px',
            }}
          >
            <Input
              className={styles.cellEditPriceInput}
              onKeyDown={(e) => {
                if (e.key === 'Escape') {
                  if (revertData) {
                    revertData(rowIndex, true);
                  }
                  if (setEditedRows) {
                    setEditedRows((old: Record<string, unknown>[]) => ({
                      ...old,
                      [row.id]: !old[Number(row.id)],
                    }));
                  }

                  if (setCancelEdition) {
                    setCancelEdition((old: Record<string, unknown>[]) => ({
                      ...old,
                      [row.id]: true,
                    }));
                  }
                }
              }}
              type="number"
              step="0.1"
              state={state}
              value={value}
              onChange={(e) => handleOnChangeInput(e.target.value)}
              label=""
              id=""
              data-testid="input-price"
            />
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};
